import {I18n} from 'react-redux-i18n';

const roleSearchFields = (searchFieldValues, entityList) => {
    return {
        rows: [
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "name",
                        label: I18n.t("roles.search.name"),
                        type: "text",
                        value: searchFieldValues.name.value,
                    },
                    {
                        id: "entityId",
                        label: I18n.t("roles.search.entity"),
                        type: "dropdown",
                        value: searchFieldValues.entityId.value,
                        data: entityList,
                    }
                ]
            },
        ]
    }
};

export {
    roleSearchFields
}